import Swal from "sweetalert2";
import { createToast } from "mosha-vue-toastify";
import "mosha-vue-toastify/dist/style.css";
//
export default {
  data() {
    return {
      baseConvert: {},
      gUserId: 2,
      gOwnerId: 6,
      gPracticeId: 3,
      gUserName: "",
      //SERVER: 'https://localhost:44301',
      SERVER: "https://dev-practiceapis.veinspracticesolution.com",
      //SERVER: 'https://practiceapis.veinspracticesolution.com',
      AssetServer: "https://dev-checkin.veinspracticesolution.com/",
      // AssetServer:"https://checkin.veinspracticesolution.com/",
      UKEY: "<VEINS2021/>",
      dummyComm: {
        userId: 0,
        ownerId: 0,
        practiceId: 0,
        auditFlag: 0,
        auditFlagVal: "NULL",
        extras: "",
        visitId: 0,
        myDate: "",
        myTime: "",
        pure: "",
      },

      //-- App data
    };
  },

  methods: {
    gFillUserInfo(operators) {
      const str = localStorage.OSversion;
      const arr = str.split(this.UKEY);
      this.gUserId = arr[0] * 1;

      const xx = operators.find((f) => f.operatorId == this.gUserId);
      this.gUserName = xx.operatorName;
    },

    isValidateDate_1(dateStr) {
      //if(dateStr == "Invalid date"){return true;}
      let Date_1 = new Date(dateStr);
      let ymdDate = this.dateToYMD(Date_1);
      var re = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
      return re.test(ymdDate);
    },

    dateToYMD(date) {
      date = new Date(date);
      var dstr =
        date.getFullYear() +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2);
      return dstr;
    },

    isValidateDate(dateStr) {
      var val = dateStr.split("-");
      var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
      var day = currentDate.getDate();
      var month = currentDate.getMonth() + 1;
      var year = currentDate.getFullYear();
      if (dateStr.substring(0, 4) >= 1900) {
        console.log("<b>" + day + "/" + month + "/" + year + "</b>");
        console.log(val);
        if (year == val[0]) {
          if (month.toString() > val[1]) {
            var re = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
            return re.test(dateStr);
          } else if (month.toString() == val[1]) {
            if (day.toString() > val[2]) {
              var re1 = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
              return re1.test(dateStr);
            } else {
              return;
            }
          } else {
            return;
          }
        } else if (year > val[0]) {
          var re_1 = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
          return re_1.test(dateStr);
        } else if (year < val[0]) {
          return;
        }
      } else {
        return;
      }
    },

    convertUTCDateToLocalDate(date) {
      var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
      var offset = date.getTimezoneOffset() / 60;
      var hours = date.getHours();
      newDate.setHours(hours - offset);
      newDate = newDate.getTime();
      return newDate;
    },

    intDummyComm() {
      const paras = this.$route.query.index;
      if (typeof paras !== "undefined" && paras.length > 1) {
        localStorage.OSversion = this.$route.query.index;
        localStorage.xeon = this.$route.query.area;

        //set router
        const str = localStorage.OSversion;
        const arr = str.split("<VEINS2021/>");
        //this.dummyComm.auditFlagVal = localStorage.OSversion;
        this.dummyComm.prId = localStorage.xeon;
        this.dummyComm.Extras1 = arr[1];
        localStorage.OSversion = this.dummyComm.Extras1;
        this.baseConvert[0] = btoa(localStorage.xeon);
        this.baseConvert[1] = btoa(arr[1]);
        this.$router.replace({
          query: { cra: this.baseConvert[0] + "&resu=" + this.baseConvert[1] },
        });
      } else {
        localStorage.OSversion = this.$route.fullPath;
        const str1 = localStorage.OSversion;
        let arr1 = str1.split("%26");
        let prac = arr1[0].split("/?cra=");
        let user = arr1[1].split("resu=");
        console.log(arr1, str1);

        localStorage.xeon = atob(prac[1]);
        this.dummyComm.Extras1 = atob(user[1]);
        this.dummyComm.prId = atob(prac[1]);
      }
      // check
      //this.mixinMakeCommString(this.gUserId,this.gOwnerId, this.gPracticeId);
      // this.dummyComm.userId=this.gUserId;
      // this.dummyComm.ownerId=this.gOwnerId;
      // this.dummyComm.practiceId=this.gPracticeId;

      // this.dummyComm.prId = this.gPracticeId;
    },

    mixinMakeCommString() {
      let x = "";
      for (var i = 0; i < arguments.length; i++) {
        x += arguments[i] + this.UKEY;
      }
      return x;
    },

    validEmail(email) {
      if (email == "") {
        return true;
      }
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    Validity(e) {
      this.warningToast("Valid email required");
      e.preventDefault();
    },

    ShowError(msg) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: msg,
      });
    },

    ShowWarning(msg) {
      Swal.fire({
        title: "Warning",
        text: msg,
      });
    },

    ShowSuccess(msg) {
      Swal.fire({
        icon: "success",
        title: "success",
        text: msg,
      });
    },

    warningToast(e) {
      createToast(e, {
        type: "danger",
        showIcon: "true",
        transition: "slide",
        timeout: 1500,
      });
    },

    successToast() {
      createToast("Information Added", {
        type: "success",
        showIcon: "true",
        transition: "slide",
        timeout: 1500,
      });
    },

    ShowErrorAutoClose(msg) {
      let timerInterval;
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: msg,
        timer: 2000,
        didOpen: () => {
          Swal.showLoading();
          timerInterval = setInterval(2000);
        },
        willClose: () => {
          clearInterval(timerInterval);
        },
      });
    },

    ShowSuccessAutoClose(msg) {
      let timerInterval;
      Swal.fire({
        icon: "success",
        title: "success",
        text: msg,
        timer: 2000,
        didOpen: () => {
          Swal.showLoading();
          timerInterval = setInterval(2000);
        },
        willClose: () => {
          clearInterval(timerInterval);
        },
      });
    },

    dateAdd(date, interval, units) {
      if (!(date instanceof Date)) return undefined;
      var ret = new Date(date);
      var checkRollover = function() {
        if (ret.getDate() != date.getDate()) ret.setDate(0);
      };
      switch (String(interval)) {
        case "y":
          ret.setFullYear(ret.getFullYear() + units);
          checkRollover();
          break;
        case "q":
          ret.setMonth(ret.getMonth() + 3 * units);
          checkRollover();
          break;
        case "M":
          ret.setMonth(ret.getMonth() + units);
          checkRollover();
          break;
        case "w":
          ret.setDate(ret.getDate() + 7 * units);
          break;
        case "d":
          ret.setDate(ret.getDate() + units);
          break;
        case "h":
          ret.setTime(ret.getTime() + units * 3600000);
          break;
        case "m":
          ret.setTime(ret.getTime() + units * 60000);
          break;
        case "s":
          ret.setTime(ret.getTime() + units * 1000);
          break;
        default:
          ret = undefined;
          break;
      }
      return ret;
    },
  }, // end methods
};
